import React from 'react';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import EventTypePill from './EventTypePill';
import styles from './styles.module.scss';

type PropsDef = {
  control: any;
  name: string;
  allowUnavailable?: boolean;
};

const EventTypeSelector = React.forwardRef((props: PropsDef, _ref) => {
  const { control, name, allowUnavailable } = props;
  const { t } = useTranslation();

  const { field } = useController({ name, control });

  const tabs = [
    { value: 'lesson_schedule', label: t("Session"), isActive: field.value === 'lesson_schedule' },
    ...(allowUnavailable ? [{ value: 'coach_schedule_block', label: t("Unavailability"), isActive: field.value === 'coach_schedule_block' }] : []),
  ];

  return (
    <div className={styles.event_type_picker}>
      {tabs.map((tab) => (
        <EventTypePill
          key={tab.value}
          label={tab.label}
          isActive={tab.isActive}
          onClick={() => field.onChange(tab.value)}
          data-testid={`event-type-${tab.value}`}
        />
      ))}
    </div>
  );
});

export default EventTypeSelector;
